// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const CountryCount = zod.object({
  "code": zod.string(),
  "count": zod.int(),
  "name": zod.string()
});

export type CountryCount = zod.input<typeof CountryCount>;
export type CountryCountOutput = zod.output<typeof CountryCount>;
